(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/shared/selector-buttons.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/shared/selector-buttons.js');


'use strict';

const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  isPollingAtom,
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  loginMethods
} = svs.iam_login.constants;
const SelectorButtons = () => {
  const isPolling = useAtomValue(isPollingAtom);
  const [activeMethod, setActiveMethod] = useAtom(activeMethodAtom);
  const onMethodClick = method => {
    setActiveMethod(method);
  };
  return (!isPolling || svs.core.detect.formfactor.desktop() && isPolling) && React.createElement(ItemsMenu, {
    branding: "sport",
    centered: true,
    className: "login-selector",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, React.createElement(LinkItem, {
    "aria-label": "Logga in med BankID",
    label: "BANKID",
    onClick: () => onMethodClick(loginMethods.bankid),
    selected: activeMethod === loginMethods.bankid
  }), React.createElement(LinkItem, {
    "aria-label": "Logga in med Freja eID",
    label: "FREJA EID",
    onClick: () => onMethodClick(loginMethods.freja),
    selected: activeMethod === loginMethods.freja
  }));
};
svs.iam_login.components.shared.SelectorButtons = SelectorButtons;

 })(window);